<template>
  <div v-if="link" class="event-cta">
    <LinkCallToAction :link="link" :link-label="linkLabel" />
  </div>
</template>

<script setup lang="ts">
import type { MultilinkStoryblok } from '~/types/storyblok'

defineProps<{ link?: MultilinkStoryblok; linkLabel?: string }>()
</script>

<style lang="less" scoped>
.event-cta {
  margin: @gutter-xl 0;
}
</style>
